import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AgeRule,
  OccupancyRule,
  PeriodsRule,
  PromotionsState,
  VoyagersClubRule,
} from '../../../../../interfaces/src/lib/types/index';

const initialState: PromotionsState = {
  id: '',
  promotionName: '',
  isApplicable: true,
  occupancyRule: undefined,
  ageRule: undefined,
  periodsRule: undefined,
  voyagersClubRule: undefined,
};

const promotionsSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    setPromotionsBookingFunnel: (state, action: PayloadAction<PromotionsState>) => {
      state.id = action.payload.id;
      state.promotionName = action.payload.promotionName;
      state.occupancyRule = action.payload.occupancyRule;
      state.ageRule = action.payload.ageRule;
      state.periodsRule = action.payload.periodsRule;
      state.voyagersClubRule = action.payload.voyagersClubRule;

      return state;
    },
    setIsPromotionApplicable: (state, action: PayloadAction<boolean>) => {
      state.isApplicable = action.payload;

      return state;
    },
    setIsSpecificRuleApplicable: (
      state,
      action: PayloadAction<{
        rule: 'occupancyRule' | 'ageRule' | 'periodsRule' | 'voyagersClubRule';
        applicability: boolean;
      }>
    ) => {
      const ruleKey = action.payload.rule as keyof PromotionsState;
      if (state[ruleKey]) {
        (state[ruleKey] as OccupancyRule | AgeRule | PeriodsRule | VoyagersClubRule).isApplicable =
          action.payload.applicability;
      }

      return state;
    },
  },
  extraReducers: (builder) =>
    builder.addCase('resetFromPriceType', (state) => {
      state.isApplicable = initialState.isApplicable;
      return state;
    }),
});

export const { setPromotionsBookingFunnel, setIsPromotionApplicable, setIsSpecificRuleApplicable } =
  promotionsSlice.actions;
export default promotionsSlice.reducer;
